import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4891dc30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity-0" }, "There is no more content.", -1))
const _hoisted_3 = ["data-index"]
const _hoisted_4 = {
  key: 0,
  class: "text-center py-2 text-gray-500"
}
const _hoisted_5 = { class: "w-full text-xs" }
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = {
  key: 1,
  class: "text-center py-2 text-gray-500"
}
const _hoisted_8 = { class: "w-full text-xs" }

import { onMounted, PropType, ref, watch } from 'vue'
import { Message } from '@/models/message'
import { useStoreModule, useUser } from '@/mixins'
import gsap from 'gsap'

import { VueEternalLoading } from '@ts-pro/vue-eternal-loading'

import MessageBubble from './MessageBubble.vue'
import dayjs from 'dayjs'

export default /*#__PURE__*/_defineComponent({
  props: {
  messages: {
    type: Array as PropType<Array<Message>>,
    default: () => []
  }
},
  emits: ['loadMore'],
  setup(__props, { emit }) {

const props = __props


const messagesList = ref<Element | null>(null)


const { selected: currentConv } = useStoreModule('conversations')
const scrollPosition = ref(0)
const { currentUser } = useUser()
const { endReachded, fetch, reset: resetMessages } = useStoreModule('messages')
const lastMessage = ref<Element>()
const isInitial = ref(true)
const animatedMessages = ref(0)
watch(
  () => currentConv.value,
  () => {
    reset()
  }
)

function reset() {
  resetMessages()
  isInitial.value = true
}

const unsubscribe = ref(null)

onMounted(() => {
  if (messagesList.value) {
    messagesList.value.scrollTo(0, 0)
  }
})
const scrollToBotom = () => {
  if (messagesList.value) {
    console.log(
      'scroll hegiht',
      messagesList.value.scrollHeight,
      scrollPosition.value
    )
    if (lastMessage.value) {
      lastMessage.value.scrollIntoView()
    } else {
      messagesList.value.scrollTo(0, messagesList.value.scrollHeight)
    }
  }
}
const scrollReached = async ({
  loaded,
  noMore
}: {
  loaded: () => void
  noMore: () => void
}) => {
  if (endReachded.value === false) {
    const items = await fetch(currentConv.value.node)
    loaded()
  } else {
    noMore()
  }
}

const offset = () => {
  return messagesList.value?.scrollTop
}

const storePosition = () => {
  if (messagesList.value) {
    const lastChild = [...messagesList.value.querySelectorAll('.message')]
    lastMessage.value = lastChild[0]
    console.log('Last chidl', lastChild[0])
  }
}

const beforeEnter = (el: HTMLElement): void => {
  el.style.opacity = '0'
  el.style.transform = 'rotateX(-45deg) scale(0.3)'
}
const enter = (el: any, done: () => void) => {
  const totalElements = getListOfChilds()
  gsap.to(el, {
    opacity: 1,
    transformOrigin: 'right',
    duration: 0.15,
    transform: 'rotateX(0deg) scale(1)',
    delay: (totalElements - el.dataset.index) * 0.15,
    ease: 'elastic.inOut(1, 0.3)',
    position: -el.dataset.index,
    onComplete: done
  })
  animatedMessages.value++
}

const getListOfChilds = () => {
  if (messagesList.value) {
    return messagesList.value.childElementCount - animatedMessages.value
  }
  return 0
}
const leave = (el: any, done: () => void) => {
  gsap.to(el, {
    opacity: 0,
    duration: 0.15,
    transform: 'rotateX(-45deg) scale(0.3)',
    ease: 'elastic.inOut(1, 0.3)',
    position: 1,
    delay: el.dataset.index * 0.15,
    onComplete: done
  })
}
// function use to decide wheater or not show date of message on top
const sameDayAsBefore = (i: number): boolean => {
  if (i == 0) {
    return false
  } else {
    const messagesDateFormate = dayjs(props.messages[i].date).format('MM/DD/YY')
    const prevDateFormate = dayjs(props.messages[i - 1].date).format('MM/DD/YY')

    return messagesDateFormate === prevDateFormate
  }
}

return (_ctx: any,_cache: any) => {
  const _component_fr_loading = _resolveComponent("fr-loading")!

  return (_openBlock(), _createElementBlock("div", {
    id: "messagesList",
    ref_key: "messagesList",
    ref: messagesList,
    class: "h-full flex flex-col relative px-4 overflow-y-auto overflow-x-hidden flex-1",
    style: {"max-height":"calc(100vh - 9.625rem)"}
  }, [
    (_unref(currentConv))
      ? (_openBlock(), _createBlock(_unref(VueEternalLoading), {
          key: 0,
          "is-initial": isInitial.value,
          "onUpdate:is-initial": _cache[0] || (_cache[0] = ($event: any) => ((isInitial).value = $event)),
          position: "top",
          margin: "200px",
          load: scrollReached,
          container: messagesList.value
        }, {
          loading: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_fr_loading)
            ])
          ]),
          "no-more": _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["is-initial", "container"]))
      : _createCommentVNode("", true),
    _createVNode(_TransitionGroup, {
      name: "messages",
      css: false,
      mode: "in-out",
      appear: "",
      onBeforeEnter: beforeEnter,
      onEnter: enter,
      onLeave: leave
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.messages, (message, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: message.id,
            class: "message-row",
            "data-index": index
          }, [
            (message.senderId == 'SYSTEM')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$date(message.date)), 1),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t(message.text)), 1)
                ]))
              : (index > 0 && sameDayAsBefore(index) == false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$date(message.date)), 1)
                  ]))
                : _createCommentVNode("", true),
            _createVNode(MessageBubble, { message: message }, null, 8, ["message"])
          ], 8, _hoisted_3))
        }), 128))
      ]),
      _: 1
    })
  ], 512))
}
}

})